import { defineMessages } from 'react-intl';

const messages = defineMessages({
  splitButtonText: {
    description: 'Text for the button that splits the shipment',
    defaultMessage: 'Split',
    id: 'IZ8e41',
  },
  applyButtonText: {
    description: 'Text for the button that applies the split action',
    defaultMessage: 'Apply',
    id: 'Ivz2Wq',
  },
  cancelButtonText: {
    description: 'Text for the button that cancels the split action',
    defaultMessage: 'Cancel',
    id: 'r4+H3o',
  },
  saveDisabledTooltip: {
    description: 'Tooltip for why save is disabled',
    defaultMessage: 'Please enter a valid quantity or click cancel',
    id: 'UufMDM',
  },
});

export default messages;
